import type { CSSProperties } from 'react';

export const FILTER_FIELD_PROJECTS = 'projects';
export const FILTER_FIELD_INVITATION = 'invitation';
export const FILTER_FIELD_RECONFIRMATION_STATUS = 'reconfirmationStatus';
export const FILTER_FIELD_PRESENCE = 'checked';
export const FILTER_FIELD_BROKER = 'brokers';
export const FILTER_FIELD_MANAGER = 'salesManager';
export const FILTER_FIELD_CALLS = 'calls';

export const FILTER_DROPDOWN_SIZES = {
  [FILTER_FIELD_PROJECTS]: { width: 300, height: 304 },
  [FILTER_FIELD_BROKER]: { width: 300, height: 304 },
  [FILTER_FIELD_MANAGER]: { width: 300, height: 348 },
  [FILTER_FIELD_INVITATION]: { width: 221, height: 208 },
  [FILTER_FIELD_RECONFIRMATION_STATUS]: { width: 230, height: 210 },
  [FILTER_FIELD_PRESENCE]: { width: 191, height: 118 },
  [FILTER_FIELD_CALLS]: { width: 130, height: 118 },
} as const;

export type FilterDropdownSize = (typeof FILTER_DROPDOWN_SIZES)[keyof typeof FILTER_DROPDOWN_SIZES];

export const getFilterDropdownStyle = ({ width, height }: FilterDropdownSize): CSSProperties =>
  ({
    '--filter-dropdown-width': `${width}px`,
    '--filter-dropdown-height': `${height}px`,
  }) as CSSProperties;

export const PRESENCE_FILTER_ALL = 'all';
export const PRESENCE_FILTER_PRESENT_ONLY = 'presentOnly';
export const PRESENCE_FILTER_ABSENT_ONLY = 'absentOnly';

export const INVITATION_FILTER_STATUS_ITEMS = [
  { label: 'Подтверждено', value: 'CONFIRMED' },
  { label: 'Ожидает подтверждения', value: 'WAITING' },
  { label: 'Отказ', value: 'REJECTED' },
];

export const RECONFIRMATION_STATUS_FILTER_ITEMS = [
  { label: 'Повторно подтверждено', value: 'CONFIRMED' },
  { label: 'Ожидает подтверждения', value: 'WAITING' },
  { label: 'Подтверждение направлено', value: 'SENT' },
  { label: 'Отказ накануне', value: 'REJECTED' },
];

export const PRESENCE_FILTER_OPTIONS = [
  { value: PRESENCE_FILTER_ALL, label: 'Все' },
  { value: PRESENCE_FILTER_PRESENT_ONLY, label: 'Только присутствовавшие' },
  { value: PRESENCE_FILTER_ABSENT_ONLY, label: 'Только отсутствовавшие' },
];

export const CALLS_FILTER_ALL = 'all';
export const CALLS_FILTER_CAN_CALL = 'canCall';
export const CALLS_FILTER_NO_CALLS = 'noCalls';

export const CALLS_FILTER_OPTIONS = [
  { value: CALLS_FILTER_ALL, label: 'Все' },
  { value: CALLS_FILTER_CAN_CALL, label: 'Можно звонить' },
  { value: CALLS_FILTER_NO_CALLS, label: 'Без звонков' },
];

export const MANAGER_FILTER_INVITING_ONLY_LABEL = 'Только приглашающие';
